import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { QuoteStateModule } from '@nibtravel/shared/data-access/quote';
import { QuoteConfigModule } from '@nibtravel/shared/data-access/quote-config';
import { RadioGroupModule } from '@nibtravel/shared/ui/forms/radio-group';
import { ServiceModule } from '@nibtravel/shared/util/service';
import { AgeAmbiguityComponent } from './age-ambiguity.component';
import { SafeHtmlModule } from '@nibtravel/shared/ui/pipes/safe-html';
import { i18nModule } from '@nibtravel/shared/util/i18n';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RadioGroupModule,
    ServiceModule,
    QuoteStateModule,
    QuoteConfigModule,
    SafeHtmlModule,
    i18nModule.forChild({
      scope: 'qqc',
      alias: 'qqc',
    }),
  ],
  declarations: [AgeAmbiguityComponent],
  exports: [AgeAmbiguityComponent],
})
export class AgeAmbiguityModule {}
